
<template>
  <div class="apn-page sub-form">
    <!-- Main -->
    <sub-form />
    <!-- Footer -->
    <apn-footer />
  </div>
</template>

<script>
import ApnFooter from '@/components/ApnFooter'
import SubForm from '@/components/SubForm'

export default {
  name: 'ApnContact',
    components: {
        ApnFooter,
        SubForm,
    },
    data() {
        return {

        }
    },
}
</script>

<style scoped lang="scss">
.sub-form {
  margin-top: var(--header-height);
  background-color: var(--theme-bg);
}
</style>
